import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../../components/MaterialBox'
import MaterialTypography from '../../../components/MaterialTypography'
import { fetchData, postData } from '../../Utils/Baseurl'
import MaterialSelect from '../../../components/MaterialSelect'
import MaterialInput from '../../../components/MaterialInput'
import MaterialButton from '../../../components/MaterialButton'
import { Grid, Stack } from '@mui/material'


const ApprovalMaster = () => {
    const [types, setTypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [levelCount, setLevelCount] = useState('');
    const [approvalConfig, setApprovalConfig] = useState({});
    const [approvalModes, setApprovalModes] = useState({});
    const [roles, setRoles] = useState([]);
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        fetchProjectTypes();
        fetchRoles();
        fetchEmployees();
    }, []);

    const fetchProjectTypes = async () => {
        try {
            const response = await fetchData("api/ProjectType/")
            setTypes(response.data)
        } catch (error) {
            console.log(error)
        }
    }

    const fetchRoles = async () => {
        try {
            const response = await fetchData("api/roles/?flag=1")
            setRoles(response.data.map(role => ({
                value: role.id,
                label: role.role
            })))
        } catch (error) {
            console.log("Error fetching roles:", error)
        }
    }

    const fetchEmployees = async () => {
        try {
            const response = await fetchData("api/create_user/?flag=1")
            setEmployees(response.data.map(emp => ({
                value: emp.id,
                label: emp.employee_name
            })))
        } catch (error) {
            console.log("Error fetching employees:", error)
        }
    }

    const fetchApprovalConfig = async (projectTypeId) => {
        try {
            const response = await fetchData(`api/ApprovalMaster/?project_type=${projectTypeId}`);

            console.log("Approval Config Response:", response.data);

            if (response.data && response.data.length > 0) {
                const approvalLevels = response.data;

                // Set level count based on array length
                setLevelCount(approvalLevels.length.toString());

                // Populate approval modes and config for each level
                const modes = {};
                const configs = {};

                approvalLevels.forEach((level, index) => {
                    // Set mode (Role or Employee)
                    modes[index] = level.approve_type === 'ROLE' ? 'Role' : 'Employee';

                    // Set selected values
                    if (level.approve_type === 'ROLE' && level.role) {
                        // Find the role in roles array using level.role
                        const selectedRole = roles.find(r => r.value === level.role);
                        console.log(`Level ${index} - Looking for role ID ${level.role}:`, selectedRole);
                        if (selectedRole) {
                            configs[index] = [selectedRole];
                        }
                    } else if (level.approve_type === 'EMP' && level.employees && level.employees.length > 0) {
                        // Extract user_ids from employees array of objects
                        const employeeIds = level.employees.map(emp => emp.user_id);
                        console.log(`Level ${index} - Employee IDs from API:`, employeeIds);

                        // Find the employees in employees array using extracted IDs
                        const selectedEmployees = employees.filter(emp =>
                            employeeIds.includes(emp.value)
                        );
                        console.log(`Level ${index} - Matched employees:`, selectedEmployees);
                        if (selectedEmployees.length > 0) {
                            configs[index] = selectedEmployees;
                        }
                    }
                });

                console.log("Setting modes:", modes);
                console.log("Setting configs:", configs);

                setApprovalModes(modes);
                setApprovalConfig(configs);
            } else {
                // No existing config, reset fields
                setLevelCount('');
                setApprovalModes({});
                setApprovalConfig({});
            }
        } catch (error) {
            console.log("Error fetching approval config:", error);
            // Reset on error
            setLevelCount('');
            setApprovalModes({});
            setApprovalConfig({});
        }
    };

    const handleTypeChange = (selectedOption) => {
        setSelectedType(selectedOption);

        if (selectedOption && selectedOption.value) {
            // Fetch existing approval configuration for this project type
            fetchApprovalConfig(selectedOption.value);
        } else {
            // Reset if no project type selected
            setApprovalModes({});
            setLevelCount('');
            setApprovalConfig({});
        }
    };

    const handleLevelModeToggle = (index) => {
        setApprovalModes(prev => {
            const current = prev[index] || 'Role';
            setApprovalConfig(prevConfig => {
                const newConfig = { ...prevConfig };
                delete newConfig[index];
                return newConfig;
            });
            return { ...prev, [index]: current === 'Role' ? 'Employee' : 'Role' };
        });
    };

    const handleLevelChange = (e) => {
        const val = e.target.value;
        if (val === '' || /^[0-9\b]+$/.test(val)) {
            setLevelCount(val);
        }
    };

    const handleConfigChange = (levelIndex, selectedOption) => {
        setApprovalConfig(prev => ({
            ...prev,
            [levelIndex]: selectedOption
        }));
    };



    const handleSubmit = async () => {
        try {
            const count = parseInt(levelCount) || 0;
            const approval_levels = [];

            for (let i = 0; i < count; i++) {
                const mode = approvalModes[i] || 'Role';
                const selectedValues = approvalConfig[i];

                if (!selectedValues || (Array.isArray(selectedValues) && selectedValues.length === 0)) {
                    alert(`Please select ${mode} for Level ${i + 1}`);
                    return;
                }

                const levelData = {
                    level: i + 1,
                    approve_type: mode === 'Role' ? 'ROLE' : 'EMP',
                    approval_mode: 'ANY',
                    is_final_level: i === count - 1
                };

                if (mode === 'Role') {
                    const roleValue = Array.isArray(selectedValues) ? selectedValues[0]?.value : selectedValues?.value;
                    levelData.role_id = roleValue;
                } else {
                    const userIds = Array.isArray(selectedValues)
                        ? selectedValues.map(emp => emp.value)
                        : [selectedValues.value];
                    levelData.user_ids = userIds;
                }

                approval_levels.push(levelData);
            }

            const payload = {
                project_type: selectedType?.value,
                no_of_level: count,
                approval_levels
            };

            console.log("Submitting payload:", payload);

            const response = await postData("api/ApprovalMaster/", payload);

            console.log("Response:", response);


            setSelectedType(null);
            setLevelCount('');
            setApprovalConfig({});
            setApprovalModes({});

        } catch (error) {
            console.error("Error submitting approval config:", error);
        }
    };

    const renderDynamicSelects = () => {
        const count = parseInt(levelCount) || 0;
        if (count <= 0) return null;

        return Array.from({ length: count }).map((_, index) => {
            const mode = approvalModes[index] || 'Role';
            return (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                    <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, border: '1px solid #e0e0e0', borderRadius: 2, padding: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <MaterialTypography variant='caption' color="text" fontWeight="bold">
                                Level {index + 1}
                            </MaterialTypography>

                            <MaterialBox
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '20px',
                                    padding: '3px',
                                    cursor: 'pointer',
                                    width: '100px',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}
                                onClick={() => handleLevelModeToggle(index)}
                            >
                                <MaterialBox
                                    sx={{
                                        position: 'absolute',
                                        left: mode === 'Role' ? '2px' : '50%',
                                        top: '2px',
                                        width: '48%',
                                        height: 'calc(100% - 4px)',
                                        backgroundColor: '#4a55a2',
                                        borderRadius: '16px',
                                        transition: 'all 0.3s ease',
                                        zIndex: 0
                                    }}
                                />
                                <MaterialTypography
                                    variant="caption"
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        zIndex: 1,
                                        color: mode === 'Role' ? '#fff' : '#666',
                                        fontWeight: mode === 'Role' ? 'bold' : 'normal',
                                        transition: 'color 0.3s ease',
                                        fontSize: '0.75rem'
                                    }}
                                >
                                    Role
                                </MaterialTypography>
                                <MaterialTypography
                                    variant="caption"
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        zIndex: 1,
                                        color: mode === 'Employee' ? '#fff' : '#666',
                                        fontWeight: mode === 'Employee' ? 'bold' : 'normal',
                                        transition: 'color 0.3s ease',
                                        fontSize: '0.75rem'
                                    }}
                                >
                                    Emp
                                </MaterialTypography>
                            </MaterialBox>
                        </Stack>

                        <MaterialSelect
                            size="small"
                            isMulti={true}
                            options={mode === 'Role' ? roles : employees}
                            value={approvalConfig[index] || null}
                            onChange={(selected) => handleConfigChange(index, selected)}
                            placeholder={`Select ${mode}`}
                            isDisabled={false}
                        />
                    </MaterialBox>
                </Grid>
            );
        });
    };

    return (
        <DashboardLayout>
            <MaterialBox sx={{ paddingX: 1 }}>
                <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2 }}>
                    <MaterialTypography variant='h6' color="dark" fontWeight="bold">
                        Approval Master
                    </MaterialTypography>
                    <MaterialTypography variant='caption' color="textSecondary">
                        You can customise the approval process for your project.
                    </MaterialTypography>
                </MaterialBox>

                <Grid container spacing={3} alignItems="flex-start">

                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color="text" fontWeight="bold">
                                Choose the project type you want to configure approval process for
                            </MaterialTypography>
                            <MaterialSelect
                                size="small"
                                options={types.map((item) => ({
                                    value: item.id,
                                    label: item.projecttype
                                }))}
                                value={selectedType}
                                onChange={handleTypeChange}
                                isDisabled={false}
                            />
                        </MaterialBox>
                    </Grid>
                </Grid>


                <Grid container spacing={3} sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color="text" fontWeight="bold">
                                Number of Levels
                            </MaterialTypography>
                            <MaterialInput
                                size="small"
                                type="text"
                                value={levelCount}
                                onChange={handleLevelChange}
                                placeholder="Enter number of levels"
                            />
                        </MaterialBox>
                    </Grid>
                </Grid>


                <Grid container spacing={2} sx={{ mt: 2 }}>
                    {renderDynamicSelects()}
                </Grid>


                <MaterialBox sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                    <MaterialButton variant="contained" color="dark" onClick={handleSubmit}>
                        Submit
                    </MaterialButton>
                </MaterialBox>

            </MaterialBox>
        </DashboardLayout>
    )
}

export default ApprovalMaster;
